module.exports = __webpack_public_path__ + "static/img/upkeep.96f13d2d.png";